import React, { useState, useEffect } from 'react';
import { InputItem, TextareaItem } from 'antd-mobile';
import ListEdit from '../components/ListEdit';
import ChannelFilter from '../components/ChannelFilter';

import { AllOperatorType } from '../utils/const';

const weightOptions = [
  { label: '高', value: 100000 },
  { label: '中', value: 100 },
  { label: '低', value: 10 },
];

// 文本短信通道配置子组件，区分运营商显示
function ConfigEditorProvider(props) {
  const {
    list,
    setList,
    sumWeight,
    provinceShowList,
    onlyShowAll,
    onlyShowNoAll,
    type,
    // setProvinceList,
    info
  } = props;

  const [listMap, setListMap] = useState({
    all: [],
    // cmcc: [],
    // cucc: [],
    // ctcc: [],
  });

  // 初始化编辑数据
  useEffect(() => {
    setShowList(list);
    // eslint-disable-next-line
  }, [list]);

  const setShowList = list => {
    const map = {};
    list.forEach(item => {
      const key = item.Provider || 'all'; // 处理provider为空字符串
      if (!map[key]) {
        map[key] = [item];
      } else {
        map[key].push(item);
      }
    });

    resetMap(map);
    setListMap(map);
  };

  const setMapList = (type, list) => {
    const map = listMap;
    map[type] = list || [];
    map[type].map(item => (item.Provider = type));
    const newMap = {
      ...listMap,
      ...map,
    };
    let newList = [];
    setListMap(newMap);

    Object.keys(AllOperatorType).forEach(
      type => (newList = newList.concat(listMap[type]))
    );
    setList(newList);
  };

  const resetMap = map => {
    Object.keys(AllOperatorType).forEach(type => {
      if (!map[type]) {
        // 补齐所有的运营商
        map[type] = [];
      }
    });
  };

  const getEditItem = (text, carriertype) => {
    return (value, onChange, index) => {
      return <div className="mr-10">
        <ChannelFilter
          value={[value.Channel]}
          filter={info && info.Purpose ? { Purpose: info.Purpose } : null}
          onChange={val => {
            if (val && val.length > 0) {
              onChange({ ...value, Channel: val[0] });
            }
          }}
        />
        <InputItem
          style={{ marginLeft: '8px', textAlign: 'end' }}
          type="number"
          placeholder="请输入权重"
          // max={sumWeight}
          value={value.Weight}
          onChange={val => {
            let result = val;
            if (val > sumWeight) { result = value.Weight = sumWeight }
            onChange({ ...value, Weight: result })
          }}
        >权重</InputItem>

        {type === 'phone' ? (
          <TextareaItem
            title="号码"
            placeholder="请输入号码，英文格式逗号隔开"
            // ref={el => this.autoFocusInst = el}
            autoHeight
            // rows={5}
            value={(value.SpecifiedPhones || []).join(',')}
            onChange={val => {
              let result = val;
              onChange({ ...value, SpecifiedPhones: (result || '').split(',') })
            }}
          />
        ) : null}
      </div>
    };
  };

  return (
    <div style={{ marginTop: '6px' }}>
      {Object.keys(AllOperatorType)
        // .filter(type => type !== 'province')
        .filter(type => {
          if (onlyShowAll) {
            return type === 'all' || type === ''
          }
          if (onlyShowNoAll) {
            return type !== 'all' && type !== ''
          }

          return true;
        })
        .map((type, index) => {
          return (
            <section key={index}>
              {
                // eslint-disable-next-line no-mixed-operators
                // 控制全部和单条运营商的显示逻辑
                <>
                  {`${AllOperatorType[type || 'all']}：`}
                  <ListEdit
                    list={listMap[type]}
                    setList={list => setMapList(type, list)}
                    renderItem={getEditItem('', type)}
                    initItem={{}}
                  />
                </>
              }
            </section>
          );
        })}

      {provinceShowList && provinceShowList.length ? (
        <>
          分省：
          {provinceShowList.map((item, index) => {
            const currentWeight = weightOptions.find(
              weight => weight.value === item.Weight
            );
            return <div key={index}>
              {/* 省份：{item.} */}
              <span>通道：{item.Channel}</span>
              <span style={{ marginLeft: '12px' }}>
                权重：
                {` ${(currentWeight && currentWeight.label) || ''}(${item.Weight || 0})`}
              </span>
            </div>
          })}
        </>
      ) : null}
    </div>
  );
}

export default ConfigEditorProvider;
